<template>
  <div class="wrapper">
    <button class="button reset-button" @click="resetHandler">
      {{ $t('common.reset') }}
    </button>
    <button class="button choose-button" @click="selectHandler(value)">
      {{ $t('common.choose') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'FilterModalButtons',
  props: {
    reset: {
      type: Function,
      default: () => 1
    },
    select: {
      type: Function,
      default: () => 1
    },
    value: {
      type: [Object, String, Number, Array],
      default: null
    }
  },
  methods: {
    resetHandler() {
      window.scrollTo({
        top: 0,
        behavior: 'auto'
      })
      this.reset()
    },
    selectHandler(val) {
      window.scrollTo({
        top: 0,
        behavior: 'auto'
      })
      this.select(val)
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  justify-content: space-between;
}
</style>
